var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"loader",attrs:{"id":"loader-primario"}},[_c('span'),_c('span'),_c('span'),_c('span')]),_c('div',{staticClass:"loaderFocus",attrs:{"id":"loader-primario-focus"}})])
}]

export { render, staticRenderFns }